<template>
	<div class="order-box__time">
		<h3
			class="order-box__time-title"
			v-html="$t('orderboxtime.title')"
		/>

		<GeneralMessage
			v-for="(message, i) in filteredYieldingMessages"
			:key="'yielding'+i"
			:message="message"
			type="promo"
			stick
		/>

		<FormInputCheckbox
			v-if="orderNowAvailable"
			class="order-box__time-checkbox"
			:checked="orderNow"
			:label="$t('orderboxtime.orderNowLabel')"
			immediate
			@input="$emit('ordernowchanged', $event)"
		/>

		<h4
			class="order-box__time-subtitle"
			v-if="orderNowAvailable && !orderNow"
			v-html="$t('orderboxtime.preorderLabel')"
		/>
		<div
			class="order-box__time-group"
			v-if="!orderNowAvailable || !orderNow"
		>
			<FormInputDate
				class="order-box__time-date"
				:placeholder="$t('forms.labels.date')"
				:label="$t('forms.labels.date')"
				:value="date"
				:initialValue="date"
				:min-date="dateMin"
				:max-date="dateMax"
				:isDateDisabled="isDateDisabled"
				required
				@input="$emit('datechanged', $event)"
			/>
			<TimePicker
				class="order-box__time-time"
				:value="time"
				:times="times"
				:label="$t('forms.labels.time')"
				@input="$emit('timechanged', $event)"
				narrow
			/>
		</div>
		<GeneralMessage
			v-if="!times.length && (!orderNow || !orderNowAvailable)"
			:message="$t('orderboxtime.noTimes')"
			type="error"
			stick
		/>
		<GeneralMessage
			v-if="uberDirect"
			:message="$t('uberDirect.deliveryOrderbox')"
			type="info"
			stick
		/>

		<Button
			class="order-box__time-button"
			level="primary"
			type="button"
			:text="buttonText"
			:disabled="!times.length && (!orderNow || !orderNowAvailable)"
			@click.prevent="$emit('click')"
		/>
	</div>
</template>

<script>
import FormInputDate from "@/components/FormInputDate"
import FormInputCheckbox from "@/components/FormInputCheckbox"
import TimePicker from "@/components/TimePicker"
import Button from '@/components/Button';
import GeneralMessage from '@/components/GeneralMessage';

export default {
	components: {
		FormInputDate,
		FormInputCheckbox,
		TimePicker,
		Button,
		GeneralMessage,
	},
	props: {
		orderNow: {
			default: false,
		},
		orderNowAvailable: {
			default: false,
		},
		date: {
			default: '',
		},
		dateMin: {
			default: '',
		},
		dateMax: {
			default: '',
		},
		isDateDisabled: {
			default: () => {}
		},
		time: {
			default: '',
		},
		times: {
			default: () => []
		},
		buttonText: {
			default: 'ändern',
		},
		yieldingMessages: {
			type: Array,
			default: () => []
		},
    uberDirect: Boolean
	},
	computed: {
		filteredYieldingMessages() {
			return this.yieldingMessages.filter(m => m)
		}
	}
}
</script>

<style>

</style>
